# Used by internal calculator and onboarding's credit card
# Based on some given fields, it handles the whole sliding display for the monthly limit selection. The screen contains
# a text input and a slider that are directly connected. Two additional fields allows the user to declae some additional
# assets in the bank. As an impact, maximal limit is recalculated and displayed again. Credit card type also triggers
# a new calculation

import _ from 'lodash'

PROPOSED_LIMIT = 'span.proposed_limit'
CREDIT_CARD_OPTION = '[name*="form[credit_card_cd]"], [name*="form[credit_card_type_cd]"]'
CREDIT_CARD_INPUTS = '
  [data-behaviour=credit-card-offer],
  [data-behaviour=credit-card-range]
'
CREDIT_CARD_AMOUNT = '[data-behaviour=credit-card-amount]'
CREDIT_CARD_RANGE = '[data-behaviour=credit-card-range]'
REQ_DELAY = 500

calculate = ->
  url = window.location.pathname.split('/')
  url[url.length-1] = 'credit_card_limit'
  $.post url.join('/'), $(@form).find('input:visible').serialize(), (data) ->
    $(PROPOSED_LIMIT).text $CAM.formatCurrency(data.proposed, shorten: false, suffix: '')
    $('.rangewrapper__label--max').html $CAM.formatCurrency(data.max, shorten: false, suffix: '')
    val = $(CREDIT_CARD_RANGE).prop('max', data.max).val()
    $(CREDIT_CARD_AMOUNT).text $CAM.formatCurrency(val, shorten: false, suffix: '')

    monthly_limit = $CAM.parseCurrency $('#monthly_limit_id').val()
    $('#second_visa_name').toggle monthly_limit > data.max_internal && monthly_limit > 1000


$(document).on 'change', CREDIT_CARD_OPTION, calculate
$(document).on 'keyup', CREDIT_CARD_INPUTS, _.debounce(calculate, REQ_DELAY)
$(document).on 'input change', CREDIT_CARD_INPUTS, ->
  if(view = $(@).data('view'))
    $(view).val(this.value)
$(document).on 'input change', CREDIT_CARD_RANGE, ->
  $(CREDIT_CARD_AMOUNT).text $CAM.formatCurrency(this.value, shorten: false, suffix: '')
